import { airportFilterCategories } from '@/constants/airportFilterConstants';

const validFilterQueryParams = new Set(Object.values(airportFilterCategories));

function encodeArray(values) {
  if (!values || values.length === 0) return null;
  return values.map((v) => encodeURIComponent(v)).join(',');
}

function decodeArray(param) {
  if (!param) return [];
  return param.split(',').map((v) => decodeURIComponent(v));
}

function getNonFilterQueryParams(search) {
  const params = new URLSearchParams(search);
  validFilterQueryParams.forEach((key) => {
    params.delete(key);
  });
  return params;
}

export function filtersToQuery(filters, search = window.location.search) {
  const params = getNonFilterQueryParams(search);
  Object.keys(filters || {}).forEach((key) => {
    const encoded = encodeArray(filters[key]);
    if (encoded) params.set(key, encoded);
  });
  return params.toString();
}

export function queryToFilters(search = window.location.search) {
  const params = new URLSearchParams(search);
  const obj = {};

  params.forEach((value, key) => {
    if (validFilterQueryParams.has(key)) {
      obj[key] = decodeArray(value);
    }
  });

  return obj;
}

export function removeFiltersQuery(search = window.location.search) {
  const params = getNonFilterQueryParams(search);
  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
}

export const hasFilters = (filters) =>
  Object.values(filters).some((arr) => arr.length > 0);

export const filterLounges = (loungesList, filters) => {
  if (!hasFilters(filters)) return loungesList;

  return loungesList.filter((lounge) => {
    // Check terminal filter
    if (
      filters[airportFilterCategories.TERMINAL]?.length > 0 &&
      !filters[airportFilterCategories.TERMINAL].includes(
        lounge.location.terminal
      )
    ) {
      return false;
    }

    // Check amenities filter
    if (filters[airportFilterCategories.AMENITIES]?.length > 0) {
      const hasAllAmenities = filters[airportFilterCategories.AMENITIES].every(
        (amenity) =>
          lounge.amenities.some((a) => {
            return (
              a.id.includes(amenity) &&
              (!(filters[airportFilterCategories.AMENITIES_COST]?.length > 0) ||
                !a.paid) // if 'Complimentary Only' is selected, filter out paid amenities
            );
          })
      );
      if (!hasAllAmenities) {
        return false;
      }
    }

    // Check if lounge is open now
    if (
      filters[airportFilterCategories.HOURS]?.length > 0 // 'Open Now' selected as it takes only one value
    ) {
      if (!lounge.isOpen) return false;
    }

    return true;
  });
};
